const headers = [
    "Buch", "Autor", "Sprache", "veröffentlicht", "Verkäufe"
];

const data = [
    ["Der Herr der Ringe", "J. R. R. Tolkien", "Englisch", "1954-1955", "150 Millionen"],
    ["Der kleine Prinz", "Antoine de Saint-Exupéry", "Französisch", "1943", "140 Millionen"],
    ["Harry Potter und der Stein der Weisen", "J. K. Rowling", "Englisch", "1997", "107 Millionen"],
    ["Und dann gabs keines mehr", "Agatha Christie", "Englisch", "1939", "100 Millionen"],
    ["Der Traum der roten Kammer", "Cáo Xuèqín", "Chinesisch", "1754-1791", "100 Millionen"],
    ["Der Hobbit", "J. R. R. Tolkien", "Englisch", "1937", "100 Millionen"],
    ["Sie", "H. Rider Haggard", "Englisch", "1887", "100 Millionen"]
];

const output = [headers, data];
export default output;